import React, { Fragment } from 'react'
import { Route } from 'react-router-dom';
import { CollectioncategoryTypeMapping, CollectioncategoryTypeMappingAddEdit } from './Pages';

export const CollectioncategoryTypeMappingRoutes = ({ match }) => (
    <Fragment>
        <Route exact path = {`${match.path}`} component={CollectioncategoryTypeMapping} />
        <Route exact path = {`${match.path}/AddEdit`} component={CollectioncategoryTypeMappingAddEdit} />
    </Fragment>
)